import { render } from "./Table.vue?vue&type=template&id=5152e0ad&scoped=true&ts=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=5152e0ad&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src536781470/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5152e0ad"]])

export default __exports__